export default {
    // 买家中心
    "buyerWeb":'http://192.168.103.168:3003',
    // 买家中心查看需求
    "buyerMess": 'http://192.168.104.48:32404/#/demand',
    // 卖家中心
    "sellerWeb":'http://192.168.104.48:32405',
    // 设计师中心
    "designerWeb":'https://designer.zengcaicloud.com',
    // "designerWeb":'http://localhost:8081',
    // 评审中心
    "reviewWeb":'https://www.fuzhiqiangqi.com/review_center',

    "payUrl":'http://192.168.104.48:32400/resource-pay/pay/',
    "cloudUrl":'http://www.fuzhiqiangqi.com/cloudUp',
    "declareUrl":'http://www.fuzhiqiangqi.com/projectApply',
    "serviceProviderUrl":'http://www.fuzhiqiangqi.com/serviceProviderList',
}



// WEBPACK FOOTER //
// ./src/utils/url.js